let rebelMenuTrigger;
let rebelHeaderObserver;
let rebelSlidesObserver;

function initializeRebelSlideAccessibility() {
  const sync = () => document.querySelectorAll('slideshow-slide.resource-list__slide').forEach((slide) => {
    slide.inert = slide.getAttribute('aria-hidden') === 'true';
  });
  sync();
  if (rebelSlidesObserver) return;
  let pending = false;
  rebelSlidesObserver = new MutationObserver(() => {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => { pending = false; sync(); });
  });
  rebelSlidesObserver.observe(document.body, {subtree: true, childList: true, attributes: true, attributeFilter: ['aria-hidden']});
}

function syncRebelMenuState(open) {
  document.querySelectorAll('[data-rebel-menu-open]').forEach((button) => button.setAttribute('aria-expanded', String(open)));
  document.documentElement.classList.toggle('rebel-menu-open', open);
}

function initializeRebelNavigation() {
  const dialog = document.querySelector('#RebelMenu');
  if (!dialog || dialog.dataset.rebelReady) return;
  dialog.dataset.rebelReady = 'true';
  let closeTimer;
  const requestClose = () => {
    if (!dialog.open || dialog.hasAttribute('data-rebel-closing')) return;
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) {
      dialog.close();
      return;
    }
    dialog.setAttribute('data-rebel-closing', '');
    closeTimer = window.setTimeout(() => { if (dialog.open) dialog.close(); }, 240);
  };
  dialog.querySelector('[data-rebel-menu-close]')?.addEventListener('click', requestClose);
  dialog.addEventListener('cancel', (event) => { event.preventDefault(); requestClose(); });
  dialog.addEventListener('keydown', (event) => {
    if (event.key !== 'Tab') return;
    const controls = [...dialog.querySelectorAll('a[href], button, summary, input, select, textarea, [tabindex]')].filter((element) => element.tabIndex >= 0 && !element.disabled && !element.closest('[inert], [hidden]') && element.getClientRects().length && getComputedStyle(element).visibility !== 'hidden');
    const first = controls[0];
    const last = controls[controls.length - 1];
    if (!first) return;
    if (event.shiftKey && (document.activeElement === first || document.activeElement === dialog)) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && (document.activeElement === last || document.activeElement === dialog)) {
      event.preventDefault();
      first.focus();
    }
  });
  dialog.addEventListener('click', (event) => {
    if (event.target !== dialog) return;
    const bounds = dialog.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) requestClose();
  });
  dialog.addEventListener('close', () => {
    window.clearTimeout(closeTimer);
    dialog.removeAttribute('data-rebel-closing');
    syncRebelMenuState(false);
    const trigger = rebelMenuTrigger?.getClientRects().length ? rebelMenuTrigger : [...document.querySelectorAll('[data-rebel-menu-open]')].find((button) => button.getClientRects().length);
    trigger?.focus();
  });
}

function initializeRebelDropdowns() {
  document.querySelectorAll('.rebel-nav__details').forEach((details) => {
    if (details.dataset.rebelReady) return;
    details.dataset.rebelReady = 'true';
    details.addEventListener('toggle', () => {
      if (!details.open) return;
      document.querySelectorAll('.rebel-nav__details[open]').forEach((other) => { if (other !== details) other.open = false; });
    });
    details.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      details.open = false;
      details.querySelector('summary')?.focus();
      event.stopPropagation();
    });
  });
}

const rebelFooterDesktop = window.matchMedia('(min-width: 750px)');
function initializeRebelFooter() {
  document.querySelectorAll('.rebel-footer__group').forEach((group) => { group.open = rebelFooterDesktop.matches; });
}
rebelFooterDesktop.addEventListener('change', initializeRebelFooter);

function initializeRebelHeaderOffsets() {
  rebelHeaderObserver?.disconnect();
  const header = document.querySelector('.rebel-header');
  if (!header) return;
  const update = () => {
    document.body.style.setProperty('--header-height', `${header.offsetHeight}px`);
    document.body.style.setProperty('--header-group-height', `${header.offsetHeight}px`);
    document.body.style.setProperty('--transparent-header-offset-boolean', '0');
  };
  update();
  rebelHeaderObserver = new ResizeObserver(update);
  rebelHeaderObserver.observe(header);
}

document.addEventListener('click', (event) => {
  const openButton = event.target.closest('[data-rebel-menu-open]');
  if (openButton) {
    const dialog = document.querySelector('#RebelMenu');
    if (dialog?.isConnected && !dialog.open) {
      rebelMenuTrigger = openButton;
      dialog.showModal();
      syncRebelMenuState(true);
    }
  }
  document.querySelectorAll('.rebel-nav__details[open]').forEach((details) => {
    if (!details.contains(event.target)) details.open = false;
  });
});

function initializeRebelChrome() {
  document.documentElement.dataset.rebelNavigationReady = 'true';
  initializeRebelNavigation();
  initializeRebelDropdowns();
  initializeRebelFooter();
  initializeRebelHeaderOffsets();
  initializeRebelSlideAccessibility();
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeRebelChrome, { once: true });
else initializeRebelChrome();
document.addEventListener('shopify:section:load', initializeRebelChrome);
